import { createFileRoute } from '@tanstack/react-router';
import { RequireService } from '@/components/shared/require-service';
import { GroupsPage } from '@/features/groups/groups-page';

export const Route = createFileRoute('/_app/settings/groups/')({
  component: () => (
    <RequireService service="GROUP_LIST">
      <GroupsPage />
    </RequireService>
  ),
});
